module.exports = __webpack_public_path__ + "static/media/logo-2_new.6a85eee9.png";